import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function initSwiper(element) {
  const swiper = new Swiper(element, {
    modules: [Navigation],
    spaceBetween: 0,
    enabled: false,
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      500: {
        spaceBetween: 8,
        enabled: true,
      },
    },
  });

  swiper.on('progress', (swiper, progress) => {
    if (progress <= 0) {
      element.classList.add('swiper--is-at-beginning');
    } else {
      element.classList.remove('swiper--is-at-beginning');
    }

    if (progress >= 1) {
      element.classList.add('swiper--is-at-end');
    } else {
      element.classList.remove('swiper--is-at-end');
    }
  });

  return swiper;
}

export function brandsSlider() {
  document.querySelectorAll('.brands-slider').forEach((parent) => {
    const more = parent.querySelector('.brands-slider__more');
    const list = parent.querySelector('.brands-slider__list');
    const swiperElement = parent.querySelector('.swiper');

    const swiper = initSwiper(swiperElement);

    if (swiper.slides.length <= 6) {
      more.hidden = true;
    }

    more.addEventListener('click', () => {
      more.hidden = true;
      list.classList.add('is-shown');
    });
  });
}
